import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractFullMessages } from '@/utils/extract'
import { AGENCY_QUOTATION_INIT_LOADING, AGENCY_QUOTATION_INIT_SUCCESS, AGENCY_QUOTATION_INIT_FAIL, QUOTE_TRAVEL_PARAM, QUOTE_TRAVEL_GENERAL, QUOTE_TRAVEL_ADJ_CANCEL, QUOTE_TRAVEL_PARAM_PLAN_LOADING, QUOTE_TRAVEL_PARAM_PLAN_SUCCESS, QUOTE_TRAVEL_PARAM_PLAN_FAIL, QUOTE_TRAVEL_APPLICANT, QUOTE_TRAVEL_RECALCULATE_LOADING, QUOTE_TRAVEL_RECALCULATE_SUCCESS, QUOTE_TRAVEL_RECALCULATE_FAIL } from '@/store/types'

export const travel = {
  async travelQuoteInit({ commit, state }) {
    const expand = {
      intermediary: state.quotation.commonForm.intermediary
    }
    const apiUrl = expandURI(state.quotationSettings.menu.travel, expand)
    if (apiUrl) {
      commit(AGENCY_QUOTATION_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(AGENCY_QUOTATION_INIT_SUCCESS, commitResult)
        if (commitResult.hasContent) {
          commit(QUOTE_TRAVEL_PARAM, commitResult.data)
        }
      } catch (error) {
        commit(AGENCY_QUOTATION_INIT_FAIL)
      }
    } else {
      commit(AGENCY_QUOTATION_INIT_FAIL, ['Invalid API URL'])
    }
  },
  async travelQuoteGeneral({ commit, state }, data) {
    // Before committing the data, we will check what is affected by the change of travelQuoteGeneral fields
    const commonForm = state.quotation.commonForm
    const travelForm = state.quotation.travelForm

    // Check if there is a change of common fields
    if (!commonForm.product || commonForm.product !== data.product || !travelForm.tripType || travelForm.tripType !== data.tripType || !travelForm.travelArea || travelForm.travelArea !== data.travelArea || travelForm.noAdult !== data.noAdult || travelForm.noChild !== data.noChild) {
      // Need clear out plan here
      commit(QUOTE_TRAVEL_ADJ_CANCEL)
    }
    // Check if there is a change of disc/comm fields (promotions)
    if (!commonForm.promotion || commonForm.promotion !== data.promotion) {
      commit(QUOTE_TRAVEL_RECALCULATE_LOADING)
    }

    commit(QUOTE_TRAVEL_GENERAL, data)
  },
  async travelQuotePlans({ commit, state }) {
    const apiUrl = state.quotation.menu.travelPlans
    if (apiUrl) {
      try {
        commit(QUOTE_TRAVEL_PARAM_PLAN_LOADING)

        const { commonForm, travelForm } = state.quotation
        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          tripType: travelForm.tripType,
          travelArea: travelForm.travelArea,
          noAdult: travelForm.noAdult,
          noChild: travelForm.noChild,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion,
          discLdg: commonForm.discLdg
        }
        const result = await http.post(apiUrl, calcForm)
        const { data } = result
        commit(QUOTE_TRAVEL_PARAM_PLAN_SUCCESS, data)
      } catch (error) {
        commit(QUOTE_TRAVEL_PARAM_PLAN_FAIL, extractFullMessages(error))
      }
    } else {
      commit(QUOTE_TRAVEL_PARAM_PLAN_FAIL)
    }
  },
  async travelQuoteRecalculate({ commit, state }) {
    const apiURI = state.quotation.menu.recalculate
    if (apiURI) {
      commit(QUOTE_TRAVEL_RECALCULATE_LOADING)
      try {
        const { commonForm, travelForm } = state.quotation
        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          tripType: travelForm.tripType,
          travelArea: travelForm.travelArea,
          noAdult: travelForm.noAdult,
          noChild: travelForm.noChild,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion,
          planNo: travelForm.planNo,
          travelType: travelForm.travelType,
          adjDiscount: commonForm.adjDiscount,
          discLdg: commonForm.discLdg
        }

        const result = await http.post(apiURI, calcForm)
        if (result.data) {
          const { data } = result
          commit(QUOTE_TRAVEL_RECALCULATE_SUCCESS, data)
        }
      } catch (err) {
        commit(QUOTE_TRAVEL_RECALCULATE_FAIL, extractFullMessages(err))
      }
    } else {
      commit(QUOTE_TRAVEL_RECALCULATE_FAIL, ['Invalid API URL'])
    }
  },
  travelQuoteApplicant({ commit, state }, data) {
    if (data && data.applicant) {
      commit(QUOTE_TRAVEL_APPLICANT, data.applicant)
    }
  }
}
